<template>
  <div>
    <nav class="sidebar-right--tabs">
      <div :class="{ active: sidebarActiveTab === 'notification' }" @click="changeTab('notification')">
        {{ $t("common.notifications") }}
      </div>
    </nav>

    <div class="sidebar-right--tab-content">
      <div class="sidebar-right--wrapper" :class="{ active: sidebarActiveTab === 'notification' }">
        <div v-if="pagination">
          <div class="line" v-if="pagination.docs.length > 0"></div>
          <div class="sidebar-right--item" v-for="item in pagination.docs" :key="item._id">
            <div class="d-flex">
              <div :class="['icon', getIconColorClass(item.type)]"><i class="iconoir-bell-notification"></i></div>
              <div>
                <div class="text">{{ item.title | translate }}</div>
                <div class="d-flex align-items-center" style="gap: 0.38rem;">
                  <div class="date">{{ item.at | date(true) }}</div>
                </div>
              </div>
            </div>
          </div>
          <template>
            <div class="d-flex justify-content-center my-3">
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="5" size="sm"></b-pagination>
              </ul>
            </div>
          </template>
        </div>
        <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
          <h5 class="text-center" id="myText">
            {{ $t("notification.empty") }}
          </h5>
        </empty>
        <content-loading v-if="isLoading" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sidebarActiveTab: "notification",
      request: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
      },
    };
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.paginate();
      },
    },
  },
  computed: {
    pagination() {
      return this.$store.getters["workspaceNotification/pagination"];
    },
    selectedWorkspace() {
      return this.$store.getters["switchWorkspace/selected"];
    },
    isLoading() {
      return this.$store.getters[`workspaceNotification/isLoading`];
    },
  },
  methods: {
    changeTab(tab) {
      this.sidebarActiveTab = tab;
    },
    paginate() {
      if (this.selectedWorkspace) {
        this.$store.dispatch("workspaceNotification/paginate", this.request);
      }
    },
    getIconColorClass(type) {
      switch (type) {
        case "ERROR":
          return "text-danger";
        case "INFO":
          return "text-info";
        case "NEWS":
          return "text-primary";
        case "SUCCESS":
          return "text-success";
        case "WARNING":
          return "text-warning";
        default:
          return "text-dark";
      }
    },
  },
};
</script>

<style scoped></style>
